<app-layout [environment]="environment"></app-layout>

<ngx-spinner type="line-spin-clockwise-fade"></ngx-spinner>
